import { preparePythonPrediction } from "./python-prediction-request";
import type { BrandElementType } from "@/core/common/types";
import { Firestore } from "firebase/firestore";
import { Functions, httpsCallable, HttpsCallable } from "firebase/functions";
import { GenericBaseInput } from "../custom-model-post-process";
import { GenericBaseResponse } from "../image-generation-from-urls-types";
import type { FirebaseBackend } from "./firebase-backend";
import { BRAND_ELEMENTS_GENERATION } from "./firebase-function-name";

export interface BrandElementsGenerationRequest extends GenericBaseInput {
  description: string;
  brandElementType: BrandElementType;
  width?: number;
  height?: number;
  publicTeamId?: string;
  predictionId?: string;
}

export interface BrandElementsGenerationResponse extends GenericBaseResponse {
  elementId?: string;
  output: string[];
}

export class BrandElementsGenerationManager {
  private getCurrentTeamId: () => string | null | undefined;

  private firestore: Firestore;

  private backend: FirebaseBackend;

  private brandElementsGeneration: HttpsCallable<
    BrandElementsGenerationRequest,
    BrandElementsGenerationResponse
  >;

  constructor({
    firestore,
    firebaseFunctions,
    backend,
    getCurrentTeamId,
  }: {
    firestore: Firestore;
    firebaseFunctions: Functions;
    backend: FirebaseBackend;
    getCurrentTeamId: () => string | null | undefined;
  }) {
    this.firestore = firestore;
    this.backend = backend;
    this.getCurrentTeamId = getCurrentTeamId;

    this.brandElementsGeneration = httpsCallable(firebaseFunctions, BRAND_ELEMENTS_GENERATION, {
      timeout: 180000,
    });
  }

  async generateBrandElements(
    request: BrandElementsGenerationRequest,
  ): Promise<BrandElementsGenerationResponse> {
    try {
      const pending = await preparePythonPrediction(
        BRAND_ELEMENTS_GENERATION,
        request,
        this.getCurrentTeamId,
      );
      const response = await this.brandElementsGeneration(pending.request);
      await pending.confirm(response.data);
      return response.data;
    } catch {
      console.error("python_prediction_submission_unconfirmed");
      throw new Error("Failed to generate images from urls");
    }
  }
}
